"use client"

import {useEffect, useState} from "react";
import {ITopic} from "@/lib/types/blogs";
import {useGet} from "@/hooks/useGet";
import {ROOT_URL} from "@/lib/constants/url";
import {useSearchParams} from "next/navigation";
import Link from "next/link";
import styles from "./MenuTopics.module.scss";


export const MenuTopics = () => {
  const search = useSearchParams();
  const topic = search.get("topic");

  const [topics, setTopics] = useState<ITopic[] | null>(null);

  const {
    response: [list],
  } = useGet({
    apiUrl: '/api/blogs/topics',
    rootUrl: ROOT_URL,
  });

  useEffect(() => {
    setTopics(list && Array.isArray(list) ? list : null);
  }, [list]);

  return (
    <nav className={styles.menu}>
      <Link href={`/blog`}>
        <div className={`${styles.link} ${topic === null && styles.active}`}>
          Все статьи
        </div>
      </Link>

      {!!topics && (
        topics.map((item: ITopic) => (
          <Link key={item.uuid} href={`/blog?topic=${item.seo_url}`}>
            <div className={`${styles.link} ${topic === item.seo_url && styles.active}`}>
              {item.title}
            </div>
          </Link>
        ))
      )}
    </nav>
  );
};
